/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Currencies
} from './schema'



export const utxCurrenciesGetAll = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Currencies[]>> => {
    return axios.get(
      `/currencies`,options
    );
  }


export const getUtxCurrenciesGetAllQueryKey = () => [`/currencies`];

    
export type UtxCurrenciesGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof utxCurrenciesGetAll>>>
export type UtxCurrenciesGetAllQueryError = AxiosError<void>

export const useUtxCurrenciesGetAll = <TData = Awaited<ReturnType<typeof utxCurrenciesGetAll>>, TError = AxiosError<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCurrenciesGetAll>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCurrenciesGetAllQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCurrenciesGetAll>>> = ({ signal }) => utxCurrenciesGetAll({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCurrenciesGetAll>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCurrenciesIndicative = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/currencies/indicative`,options
    );
  }


export const getUtxCurrenciesIndicativeQueryKey = () => [`/currencies/indicative`];

    
export type UtxCurrenciesIndicativeQueryResult = NonNullable<Awaited<ReturnType<typeof utxCurrenciesIndicative>>>
export type UtxCurrenciesIndicativeQueryError = AxiosError<unknown>

export const useUtxCurrenciesIndicative = <TData = Awaited<ReturnType<typeof utxCurrenciesIndicative>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCurrenciesIndicative>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCurrenciesIndicativeQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCurrenciesIndicative>>> = ({ signal }) => utxCurrenciesIndicative({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCurrenciesIndicative>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

